import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import ValidationService from '../../Services/ValidationService';
import WithRender from './AddRequest.html';
import { Inject } from 'vue-di-container';
import { RequestModel } from './RequestModel';
import { AttachmentModel } from './AttachmentModel';
import AddRequestService from './AddRequestService';
import { Toaster } from '../../Services/toast';
import { DropdownModel, ProviderModel } from '../Provider/ProviderModel';
import { SenderType } from '../../shared/Enums/SenderType';
import { CITCKeywordsModel } from '../CITCKeywords/CITCKeywordsModel';
import CITCKeywordsService from '../CITCKeywords/CITCKeywordsService';
import ProviderService from '../Provider/ProviderService';
import UserService from '../../shared/userService/UserService';
import UserModel from '../../shared/userService/Model/UserModel';
import { AttachmentCategoryModel } from './AttachmentCategoryModel';
import AttachmentCategoryService from '../AttachmentCategory/AttachmentCategoryService';
import { AttachmentCategoryType } from '../../shared/Enums/AttachmentCategory';
import RatingService from '@/components/Rating/RatingService';
import { RatingServiceType } from '@/components/Rating/RatingServiceType';
import { ServiceRatingModel } from '@/components/Rating/ServiceRatingModel';
import OperatorService from '@/Services/OperatorService';

import moment from 'moment';
import { SenderAIFieldModel } from './SenderModel';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        AddRequestService,
        CITCKeywordsService,
        ProviderService,
        AttachmentCategoryService,
        RatingService,
        OperatorService
    ],
})
export default class AddRequest extends Vue {
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(AddRequestService) public addRequestService!: AddRequestService;
    @Inject(CITCKeywordsService) public cITCKeywordsService!: CITCKeywordsService;
    @Inject(ProviderService) public providerService!: ProviderService;
    @Inject(AttachmentCategoryService) public attachmentCategoryService!: AttachmentCategoryService;
    @Inject(UserService) public userService!: UserService;
    @Inject(RatingService) public ratingService!: RatingService;
    @Inject(OperatorService) public operatorService!: OperatorService;
    @Prop({ type: Number, required: true }) public serviceType!: number;
    @Prop({ type: Boolean, default: false })
    @Ref('fileName') fileNameRef!: HTMLInputElement;

    public aiUnavailable: boolean = false;
    public isAutoSuggest: boolean = false;
    public selectedSuggestedSenderName: string | null = null;
    private suggestedSenderNamesList: Array<string> = [];
    private showSuggestions: boolean = false;
    public layoutSup: boolean | any;
    public stepNumber: number = 1;
    public verifyCounter: number = 0;
    public verified: boolean = false;
    public providerId: string = '';
    public senderName: string = '';
    public typeFile: number = 0;
    public senderNameLength: number = 11;
    public selectedFileName: string = '';
    public senderType: number[] = [];
    public keywordsList: CITCKeywordsModel[] = [];
    public attachmentCategoryList: AttachmentCategoryModel[] = [];
    public deletedAttachmentCategoryList: AttachmentCategoryModel[] = [];
    public sendersList: string[] = [];
    public submitRequestdialog: boolean = false;
    public mismatchFounddialog: boolean = false;
    public isCriticalSender: boolean = false;
    public showOperators: boolean = false;
    public senderNameId: number = 0;
    public minDate: Date = new Date();
    public managerList: any[] = [];
    public user: UserModel = {
        userId: '',
        username: '',
        details: {
            Email: '',
            MobilePhone: '',
            Operator: '',
            Provider: '',
            OperatorId: '',
            ProviderId: '',
            TenantId: '',
            Role: '',
            ChangePasswordRequired: '',
        },
    };
    public showRatingDialog: boolean = false;
    public rating: number = 0;
    public reason: string = '';
    public submitting: boolean = false;
    public provider: ProviderModel = {
        name: '',
        providerCode: '',
        id: '',
        createdDate: null,
        enterpriseUnifiedNumber: '',
        accreditationNumber: '',
        email: '',
        taxNumber: '',
        hasInternational: false,
        country: '',
        city: '',
        district: '',
        streetName: '',
        buildingNumber: '',
        postalCode: '',
        vatNumber: '',
        additionalNumber: '',
        otherIdentifier: '',
        balance: 0,
        creditLimitAmount: 0,
        bankAccountNumber: '',
        expireDate: '',
        state: '',
        isDisconnected: '',
        integrationBaseURL: ''
    };
    public customerTypeList: DropdownModel[] = [
        {
            id: 1,
            name: this.$t('shared.government').toString(),
        },
        {
            id: 2,
            name: this.$t('shared.charity').toString(),
        },
        {
            id: 3,
            name: this.$t('shared.private').toString(),
        },
        {
            id: 4,
            name: this.$t('shared.international').toString(),
        },
    ];
    public operatorList: string[] = [];

    public senderTypeList: DropdownModel[] = [
        {
            id: SenderType.Advertisement,
            name: this.$t('shared.advertisement').toString(),
        },
        {
            id: SenderType.Service,
            name: this.$t('shared.service').toString(),
        },
        {
            id: SenderType.Awareness,
            name: this.$t('shared.awareness').toString(),
        },
        {
            id: SenderType.Warning,
            name: this.$t('shared.warning').toString(),
        },
    ];
    public zainEmail: string = '';
    public STCEmail: string = '';
    public MobilyEmail: string = '';
    public SalamEmail: string = '';
    public model: RequestModel = {
        duration: '1',
        startDate: '',
        clientName: '',
        customerType: 0,
        crNumber: '',
        enterpriseUnifiedNumber: '',
        representativeEmail: '',
        representativeIdNumber: '',
        representativeMobile: '',
        representativeName: '',
        senderNames: [],
        senderRequestAttachments: [],
        requestType: 1,
        comment: '',
        expiryDate: '',
        operators: [],
        isAutoActivation: false,
        isAutoPaid: false,
        verificationType: 0,
        hasTrademark: false,
        trademarkName: '',
        protectionDateFrom: '',
        protectionDateTo: '',
    };
    public protectionFromMenu: boolean = false;
    public protectionToMenu: boolean = false;
    public domainName: string = '';
    public attachmentType: string = '';
    public managerId: string = '';
    public currentAttachment: AttachmentModel =
        {
            id: '',
            fileName: '',
            fileContent: '',
            file: null,
            attachmentType: '',
            attachmentTypeName: '',
            isDeleted: false,
        };
       
    public senderNameSymbolError: string | null = null;
    public loadingAIReview: boolean = false;
    public aiReviewProgress: number = 0;
    public aiReviewProgressInterval: any = null;

    public aiReviewRows: Array<{
        fieldKey: string;
        fieldName: string;
        providerInput: string | null;
        aiResult: string;
        status: number;
        source?: string;
        sourceSection?: any;
    }> = [];

    public aiReviewAlerts: string[] = [];
    public invalidAttachmentNote: string | null = null;

    public stampValidation = {
        chamberStamp: false,
        delegationLetterStamp: false,
        entityStamp: false
    };

    public aiReviewHeaders: any = [
        { text: this.$t('shared.fieldName'), value: 'fieldName', align: 'center', sortable: false },
        { text: this.$t('shared.providerInput'), value: 'providerInput', align: 'center', sortable: false },
        { text: this.$t('shared.aiResult'), value: 'aiResult', align: 'center', sortable: false },
        { text: this.$t('shared.status'), value: 'status', align: 'center', sortable: false },
    ];

    public get stampList() {
        if (this.model.customerType === 3) {
            return [
                { key: 'delegationLetterStamp', prop: 'delegationLetterStamp' },
                { key: 'entityStamp', prop: 'entityStamp' },
                { key: 'chamberStamp', prop: 'chamberStamp' },
            ];
        }
        return [
            { key: 'delegationLetterStamp', prop: 'delegationLetterStamp' },
            { key: 'entityStamp', prop: 'entityStamp' },
        ];
    }

    public showmismatchFoundDialog(id: string) {
        if (this.loadingAIReview) return;
        this.mismatchFounddialog = true;
    }
    public hidemismatchFoundDialog() {
        this.mismatchFounddialog = false;
    }

    public get labelMap(): { [key: string]: string } {
        return this.customerLabelMaps[this.model.customerType] || {};
    }

    public customerLabelMaps: { [key: number]: { [key: string]: string } } = {
        1: {
            auth_number: this.$t('labels.budgetNumber').toString(),
            entity_name: this.$t('labels.clientName').toString(),
            expiry_date: this.$t('labels.expiryDate').toString(),
            authorized_name_to_use: this.$t('labels.representativeName').toString(),
            authorized_mobile_to_use: this.$t('labels.representativePhone').toString(),
            authorized_email_to_use: this.$t('labels.representativeEmail').toString(),
        },
        2: {
            auth_number: this.$t('labels.licenseNumber').toString(),
            entity_name: this.$t('labels.clientName').toString(),
            expiry_date: this.$t('labels.expiryDate').toString(),
            authorized_name_to_use: this.$t('labels.representativeName').toString(),
            authorized_mobile_to_use: this.$t('labels.representativePhone').toString(),
            authorized_email_to_use: this.$t('labels.representativeEmail').toString(),
            enterprise_unified_number: this.$t('labels.unifiedEnterpriseNumber').toString(),
            start_protection: this.$t('shared.protectionDateFrom').toString(),
            end_protection: this.$t('shared.protectionDateTo').toString(),
            brand_name: this.$t('shared.trademarkName').toString(),
        },
        3: {
            enterprise_unified_number: this.$t('labels.unifiedEnterpriseNumber').toString(),
            entity_name: this.$t('labels.clientName').toString(),
            expiry_date: this.$t('labels.expiryDate').toString(),
            authorized_name_to_use: this.$t('labels.representativeName').toString(),
            authorized_mobile_to_use: this.$t('labels.representativePhone').toString(),
            authorized_email_to_use: this.$t('labels.representativeEmail').toString(),
            authorized_id: this.$t('labels.representativeId').toString(),
            start_protection: this.$t('shared.protectionDateFrom').toString(),
            end_protection: this.$t('shared.protectionDateTo').toString(),
            brand_name: this.$t('shared.trademarkName').toString(),
        }
    };

    public latestPayload: any = null;

    public async created() {
        const response = await this.operatorService.getAll();

        if (response.isSuccess) {
            this.operatorList = response.result.map((op: any) => op.name);
        }

        this.$emit('childinit', this.layoutSup);
        const keywordsListdata = await this.cITCKeywordsService.getAll();
        this.keywordsList = keywordsListdata.result;
        this.user = await this.userService.getUser();
        this.providerId = this.user.details.ProviderId;
        this.provider = await this.providerService.GetById(this.providerId);
        if (!this.provider.hasInternational) {
            this.customerTypeList.splice(3, 1);
        }
        const attachmentCategoryData = await this.attachmentCategoryService.getAll();
        this.attachmentCategoryList = attachmentCategoryData.result;
    }

    public async next() {
        if (this.stepNumber === 2) {
            if ((this.model.customerType === 2 || this.model.customerType === 3) && this.model.hasTrademark) {
                if (!this.model.trademarkName || !this.model.protectionDateFrom || !this.model.protectionDateTo) {
                    Toaster.error(this.$t('shared.trademarkRequired').toString());
                    return;
                }
                const from = new Date(this.model.protectionDateFrom);
                const to = new Date(this.model.protectionDateTo);
                if (isNaN(+from) || isNaN(+to) || from > to) {
                    Toaster.error(this.$t('shared.invalidDateRange').toString());
                    return;
                }
            }
            for (const s of this.model.senderNames) {
                if (this.domainRequired(s.senderName) && !(s.domainName && s.domainName.trim())) {
                    Toaster.error(this.$t('shared.domainNameRequiredFor').toString());
                    return;
                }
            }
        }
        if (this.stepNumber === 3 && this.model.verificationType == 1) {
            if (!/^\d{10}$/.test(this.model.representativeIdNumber)) {
                Toaster.error("Representative ID must be 10 digits");
                return;
            }
            if (this.model.representativeIdNumber !== this.managerId) {
                Toaster.error("The representative ID doesn't match the selected manager's ID");
                return;
            }
            this.stepNumber += 1;
            return;
        }

        if (this.stepNumber === 4) {
            if (!this.isValidComment()) return;
            if (!this.validateAttachmnet()) return;
            if (this.senderName !== '') this.AddSender();

            if (this.model.customerType === 4) {
                this.stepNumber = 6;
                return;
            }

            this.invalidAttachmentNote = null;
            this.loadingAIReview = true;
            this.aiReviewProgress = 0;
            this.stepNumber = 5;

            if (Array.isArray(this.aiReviewAlerts)) this.aiReviewAlerts.splice(0);

            clearInterval(this.aiReviewProgressInterval);
            this.aiReviewProgressInterval = setInterval(() => {
                if (this.aiReviewProgress < 98) this.aiReviewProgress += 1;
            }, 300);

            try {
                const response = await this.addRequestService.validateAttachments(this.model);

                if (!(response && response.isSuccess && response.data)) {
                    this.endLoading(true);
                    this.aiUnavailable = true;
                    this.aiReviewRows = [];
                    this.invalidAttachmentNote = this.$t('shared.aiUnavailableProceed').toString();
                    this.stepNumber = 5;                  
                    return;
                }

                const payload = typeof response.data === 'string'
                    ? JSON.parse(response.data)
                    : response.data;

                this.latestPayload = payload;

                if (this.isAIUnavailablePayload(payload)) {
                    this.markAIUnavailable();
                    return;
                }
                if (this.hasInvalidUploadedDocument(payload)) {
                    this.endLoading(false);
                    this.invalidAttachmentNote = this.$t('shared.invalidAttachmentNote').toString();
                }


                const vm = this.extractValidationMessages(payload);
                if (vm.hardErrors.length) {
                    this.endLoading(true);
                    this.failAndBack(vm.hardErrors);
                    return;
                }

                if (Array.isArray(vm.alerts) && vm.alerts.length) {
                    this.aiReviewAlerts.splice(0, this.aiReviewAlerts.length, ...vm.alerts);
                } else {
                    this.aiReviewAlerts.splice(0); 
                }

                const isGov = this.model.customerType === 1;
                const isCharity = this.model.customerType === 2;
                const isPrivate = this.model.customerType === 3;

                const hasSaudiDomainAtt = this.hasAttachmentByType(AttachmentCategoryType.SaudiDomain);
                const hasTrademarkAtt = this.hasAttachmentByType(AttachmentCategoryType.Trademark);

                const baseGov = ['auth_number', 'entity_name', 'expiry_date', 'authorized_name_to_use', 'authorized_mobile_to_use', 'authorized_email_to_use'];
                const baseCharity = ['auth_number', 'enterprise_unified_number', 'entity_name', 'expiry_date', 'authorized_name_to_use', 'authorized_mobile_to_use', 'authorized_email_to_use'];
                const basePrivate = ['enterprise_unified_number', 'entity_name', 'expiry_date', 'authorized_name_to_use', 'authorized_mobile_to_use', 'authorized_email_to_use'];
                if (this.model.verificationType === 1 && isPrivate) basePrivate.push('authorized_id');

                const allowedKeys = isGov ? baseGov : (isCharity ? baseCharity : (isPrivate ? basePrivate : []));
                if (hasTrademarkAtt) {
                    allowedKeys.push('brand_name', 'start_protection', 'end_protection');
                }

                type RowCandidate = {
                    fieldKey: string;
                    providerInput: string | null;
                    aiResult: any;
                    status: number;
                    source: string;
                };

                const statusScore = (status: number) => (status === 0 ? 2 : status === 1 ? 1 : 0);
                const sourceScore = (src: string) => (src === 'authorization_validation' ? 1 : 0);

                const sectionToCandidates = (sectionName: string, sectionObj: any): RowCandidate[] => {
                    if (!sectionObj) return [];
                    const out: RowCandidate[] = [];
                    const pushList = (list: any[], s: number) => {
                        if (!list || !Array.isArray(list)) return;
                        for (let i = 0; i < list.length; i++) {
                            const f = list[i];
                            if (!f || typeof f !== 'object') continue;
                            out.push({
                                fieldKey: String(f.field || ''),
                                providerInput: Object.prototype.hasOwnProperty.call(f, 'user')
                                    ? (f.user != null ? String(f.user) : null)
                                    : null,
                                aiResult: f.extracted,
                                status: s,
                                source: sectionName
                            });
                        }
                    };
                    pushList(sectionObj.matched, 0);
                    pushList(sectionObj.mismatched, 1);
                    pushList(sectionObj.missing, 2);
                    return out;
                };

                const sectionsOrder = [
                    'authorization_validation',
                    'commercial_registration_validation',
                    'hrsd_license_validation',
                    'intellectual_property_validation',
                    'domain_validation'
                ];

                const candidates: RowCandidate[] = [];
                for (let i = 0; i < sectionsOrder.length; i++) {
                    const sec = sectionsOrder[i];
                    const secObj = payload && payload[sec];
                    const list = sectionToCandidates(sec, secObj);
                    for (let j = 0; j < list.length; j++) candidates.push(list[j]);
                }

                const bestByKey: Map<string, RowCandidate> = new Map();
                for (let i = 0; i < candidates.length; i++) {
                    const c = candidates[i];
                    if (allowedKeys.indexOf(c.fieldKey) === -1) continue;
                    const prev = bestByKey.get(c.fieldKey);
                    if (!prev) {
                        bestByKey.set(c.fieldKey, c);
                        continue;
                    }
                    const prevScore = statusScore(prev.status) + sourceScore(prev.source);
                    const curScore = statusScore(c.status) + sourceScore(c.source);
                    if (curScore > prevScore) bestByKey.set(c.fieldKey, c);
                }

                const rows: Array<{
                    fieldKey: string;
                    fieldName: string;
                    providerInput: string | null;
                    aiResult: string;
                    status: number;
                    source?: string;
                    sourceSection?: any;
                }> = [];

                const labelMap = this.labelMap;
                bestByKey.forEach((f, key) => {
                    const ai = this.normalizeAiResultDisplay(f.aiResult);
                    const isHijriField = key === 'start_protection' || key === 'end_protection';

                    rows.push({
                        fieldKey: key,
                        fieldName: labelMap[key] || key,
                        providerInput: isHijriField
                            ? this.toGregorianDisplay(f.providerInput || '')
                            : (f.providerInput),
                        aiResult: isHijriField
                            ? this.toGregorianDisplay(ai)
                            : ai,
                        status: f.status,
                        sourceSection: (this.latestPayload && f.source && this.latestPayload[f.source])
                            ? (function (srcKey: string, root: any) { const o: any = {}; o[srcKey] = root[srcKey]; return o; })(f.source, this.latestPayload)
                            : null
                    });
                });


                const providerSenders: string[] = (this.model.senderNames || [])
                    .map((s: any) => (s && s.senderName) ? this.normalizeSenderForCount(s.senderName) : '')
                    .filter((s: string) => s.length > 0);
                const sBlock = (payload && payload.sender_id_validation) ? payload.sender_id_validation : {};
                const aBlock = (payload && payload.authorization_validation) ? payload.authorization_validation : {};

                const authExtracted: string[] = [];
                const authUser: string[] = [];

                function pushFrom(items: any[] | undefined | null) {
                    if (!Array.isArray(items)) return;
                    for (let i = 0; i < items.length; i++) {
                        const m = items[i];
                        if (!m || String(m.field) !== 'sender_id') continue;

                        const exArr = Array.isArray(m.extracted) ? m.extracted : (m.extracted != null ? [m.extracted] : []);
                        const usrArr = Array.isArray(m.user) ? m.user : (m.user != null ? [m.user] : []);

                        for (let j = 0; j < exArr.length; j++) authExtracted.push(String(exArr[j]));
                        for (let j = 0; j < usrArr.length; j++) authUser.push(String(usrArr[j]));
                    }
                }

                pushFrom(aBlock && aBlock.matched);
                pushFrom(aBlock && aBlock.mismatched);

                const sBlockCandidates = (sBlock && Array.isArray(sBlock.matched_senders))
                    ? sBlock.matched_senders.map((x: any) => String(x))
                    : [];

                const allCandidates: string[] = sBlockCandidates.slice(0);
                if (authExtracted.length > 0) {
                    for (let i = 0; i < authExtracted.length; i++) allCandidates.push(authExtracted[i]);
                } else if (authUser.length > 0) {
                    for (let i = 0; i < authUser.length; i++) allCandidates.push(authUser[i]);
                }

                const dedupMap: { [k: string]: string } = {};
                for (let i = 0; i < allCandidates.length; i++) {
                    const c = String(allCandidates[i]);
                    const k = this.normalizeSenderForCount(c).toLowerCase();
                    if (!Object.prototype.hasOwnProperty.call(dedupMap, k)) dedupMap[k] = c;
                }
                const uniqueCandidates = Object.keys(dedupMap).map(k => dedupMap[k]);

                const preferredDisplayRaw = (authExtracted[0] || authUser[0] || sBlockCandidates[0] || '');
                const preferredDisplay = preferredDisplayRaw ? String(preferredDisplayRaw) : this.$t('shared.notDetected').toString();

                const seenProv: { [k: string]: string } = {};
                for (let i = 0; i < providerSenders.length; i++) {
                    const provName = providerSenders[i];
                    const key = this.normalizeSenderForCount(provName).toLowerCase();
                    if (Object.prototype.hasOwnProperty.call(seenProv, key)) continue;
                    seenProv[key] = provName;

                    const hit = uniqueCandidates.find((c: string) =>
                        this.normalizeSenderForCount(c).toLowerCase() === key
                    );

                    rows.push({
                        fieldKey: 'sender_id',
                        fieldName: this.$t('shared.senderName').toString(),
                        providerInput: provName,
                        aiResult: hit ? String(hit) : String(preferredDisplay),
                        status: hit ? 0 : 1,
                        sourceSection: { sender_id_validation: sBlock, authorization_validation: aBlock }
                    });
                }

                if (hasSaudiDomainAtt) {
                    const sBlock = (payload && payload.sender_id_validation) ? payload.sender_id_validation : {};
                    const dBlock = (payload && payload.domain_validation) ? payload.domain_validation : {};

                    const sDomain = (sBlock && Object.prototype.hasOwnProperty.call(sBlock, 'domain_name'))
                        ? (sBlock.domain_name !== null ? String(sBlock.domain_name) : null)
                        : null;

                    const providerDomains: string[] = [];
                    const sns = this.model.senderNames || [];
                    for (let i = 0; i < sns.length; i++) {
                        const dn = sns[i] && sns[i].domainName ? String(sns[i].domainName).trim() : '';
                        if (dn) providerDomains.push(dn);
                    }

                    const matchedList = Array.isArray(dBlock && dBlock.matched) ? dBlock.matched : [];
                    const mismatchedList = Array.isArray(dBlock && dBlock.mismatched) ? dBlock.mismatched : [];
                    const missingList = Array.isArray(dBlock && dBlock.missing) ? dBlock.missing : [];

                    let status = 2;          
                    let aiResult = 'Not Found';

                    if (matchedList.length > 0) {
                        status = 0;          
                        aiResult = sDomain || 'Not Found';

                    } else if (mismatchedList.length > 0) {
                        const target = mismatchedList.find((x: any) => x && String(x.field) === 'sender_id') || mismatchedList[0];

                        let extracted = target && target.extracted;
                        let extractedValue: string | null = null;

                        if (Array.isArray(extracted)) {
                            extractedValue = extracted.length ? String(extracted[0]) : null;
                        } else if (extracted != null) {
                            extractedValue = String(extracted);
                        }

                        if (extractedValue) {
                            aiResult = `${extractedValue.toLowerCase()}.sa`;
                        } else {
                            aiResult = 'Not Found';
                        }
                        status = 1;         

                    } else if (missingList.length > 0) {
                        status = 2;
                        aiResult = 'Not Found';
                    }

                    rows.push({
                        fieldKey: 'domain_name',
                        fieldName: this.$t('shared.domainName').toString(),
                        providerInput: providerDomains.length ? providerDomains.join(' - ') : null,
                        aiResult,
                        status,
                        sourceSection: { sender_id_validation: sBlock, domain_validation: dBlock }
                    });
                }

                this.aiReviewRows = rows;

                const av = payload && payload.authorization_validation ? payload.authorization_validation : {};
                const delegation = this.asBool(av['has_authorization_letter']);
                const entity = this.asBool(av['has_establishment_stamp']);
                const chamber = isPrivate ? this.asBool(av['has_chamber_commerce_stamp']) : false;

                this.stampValidation = {
                    chamberStamp: chamber,
                    delegationLetterStamp: delegation,
                    entityStamp: entity
                };


                this.endLoading(false);
                this.stepNumber = 5;
                this.aiUnavailable = false;
            } catch (error) {
                this.endLoading(true);
                this.aiUnavailable = true;
                this.aiReviewRows = [];
                this.aiReviewAlerts.splice(0);
                this.invalidAttachmentNote = this.$t('shared.aiUnavailableProceed').toString();
                this.stepNumber = 5;
                return;
            }
            return;
        }

        this.stepNumber += 1;
    }


    private endLoading(forceTo100: boolean) {
        clearInterval(this.aiReviewProgressInterval);
        if (forceTo100) this.aiReviewProgress = 100;
        this.loadingAIReview = false;
    }

    private buildAIDocFieldsFromReviewRows(): SenderAIFieldModel[] {
        if (this.aiUnavailable) {
            return [{
                fieldName: '__AI_FAILED__',
                providerInput: '',
                aiResult: 'AI Failed',
                status: 2,
                source: '{}'
            }];
        }

        const rows = this.aiReviewRows || [];
        const list: SenderAIFieldModel[] = [];

        for (let i = 0; i < rows.length; i++) {
            const r = rows[i];
            list.push({
                fieldName: r.fieldKey,
                providerInput: (r.providerInput != null ? r.providerInput : ''),
                aiResult: (r.aiResult != null ? r.aiResult : ''),
                status: r.status,
                source: JSON.stringify(r.sourceSection || {})
            });
        }

        const addStamp = (fieldName: string, ok: boolean, sectionObj: any) => {
            list.push({
                fieldName,
                providerInput: '',
                aiResult: ok ? 'true' : 'false',
                status: ok ? 0 : 1,
                source: JSON.stringify(sectionObj || {})
            });
        };

        const authSectionWrapped = (this.latestPayload && this.latestPayload.authorization_validation)
            ? { authorization_validation: this.latestPayload.authorization_validation }
            : {};
        addStamp('delegationLetterStamp', this.stampValidation.delegationLetterStamp, authSectionWrapped);
        addStamp('entityStamp', this.stampValidation.entityStamp, authSectionWrapped);
        if (this.model.customerType === 3) {
            addStamp('chamberStamp', this.stampValidation.chamberStamp, authSectionWrapped);
        }
        if (list.length === 0) {
            list.push({
                fieldName: '__AI_FAILED__',
                providerInput: '',
                aiResult: 'AI Failed',
                status: 2,
                source: '{}'
            });
        }
        return list;
    }

    public async verify() {
        if (this.stepNumber === 1) {
            if (this.model.enterpriseUnifiedNumber == '') {
                Toaster.error('Enterprise Unified Number Cannot be Empty');
                return;
            }
            const response = await this.addRequestService.verify(this.model.enterpriseUnifiedNumber);
            if (response.isSuccess) {
                this.verifyCounter += 1;
                this.model.crNumber = response.crNumber;
                this.model.clientName = response.companyName
                this.managerList = response.managers;
                if (this.model.customerType === 3 && this.model.verificationType == 1) {
                    this.managerList = this.managerList.map(m => ({
                        ...m,
                        maskedName: this.getMaskedManagerName(m.key)
                    }));
                }
                this.verified = true;
            } else {
                if (response.isValidRequest) {
                    this.verifyCounter += 1;
                }
                Toaster.error(response.errorMessage);
            }
            if (this.verifyCounter == 3) {
                this.model.verificationType = 0;
            }
        }
    }

    public validateAttachmnet(): boolean {
        if (this.model.senderRequestAttachments.filter((x) => x.attachmentType === AttachmentCategoryType.DelegationLetter).length === 0) {
            Toaster.error(this.$t('shared.canNotAddArequestWithoutADelegationLetter').toString());
            return false;
        } else if (this.model.customerType === 3 &&
            this.model.senderRequestAttachments.filter((x) => x.attachmentType === AttachmentCategoryType.CommercialRegistrationDocument).length === 0) {
            Toaster.error(this.$t('shared.canNotAddArequestWithoutCommercialRegistrationAttach').toString());
            return false;
        }
        else if (this.model.customerType === 2 &&
            this.model.senderRequestAttachments.filter((x) => x.attachmentType === AttachmentCategoryType.HRSDLicense).length === 0) {
            Toaster.error(this.$t('shared.canNotAddArequestWithoutHRSDLicenseAttach').toString());
            return false;
        }

        if (this.requiresSaudiDomainAttachment()) {
            if (!this.hasAttachmentByType(AttachmentCategoryType.SaudiDomain)) {
                Toaster.error(this.$t('shared.saudiDomainCertificateRequired').toString());
                return false;
            }
        }

        if (this.requiresTrademarkAttachmentMandatory()) {
            if (!this.hasAttachmentByType(AttachmentCategoryType.Trademark)) {
                Toaster.error(this.$t('shared.trademarkCertificateRequired').toString());
                return false;
            }
        }
        return true;
    }

    public back() {
        if (this.isBackDisabled) return;
        if (this.model.customerType === 4 && this.stepNumber === 6) {
            this.stepNumber = 4;
            return;
        }
        this.stepNumber = Math.max(1, this.stepNumber - 1);
    }

    onManagerChange(selectedId: string) {
        const selectedManager = this.managerList.find(m => m.value === selectedId);
        if (selectedManager) {
            this.model.representativeName = selectedManager.key;
        }
    }


    @Watch('model.enterpriseUnifiedNumber')
    public onchangeEnterpriseNumber(newVal: string, oldVal: string) {
        if (this.verified) {
            this.verified = false;
        }

        if (this.model.verificationType == 1) {
            // Remove non-digit characters
            let val = newVal.replace(/\D/g, '');

            // Ensure it starts with 7
            if (val && !val.startsWith('7')) {
                val = '7' + val.replace(/^7*/, ''); // Enforce starting with 7
            }

            this.model.enterpriseUnifiedNumber = val;
        } else {
            // Keep original value (already assigned by v-model)
            this.model.enterpriseUnifiedNumber = newVal;
        }

        if (this.model.verificationType == 1) {
            this.model.clientName = '';
            this.model.crNumber = '';
        }
    }


    @Watch('model.customerType', { deep: true })
    public onchangeCustomerType() {
        this.model.crNumber = '';
        this.model.enterpriseUnifiedNumber = '';
        if (this.model.customerType !== 3) {
            this.model.verificationType = 0;
        }
        switch (this.model.customerType) {
            case 1:
                this.senderTypeList = [
                    {
                        id: SenderType.Advertisement,
                        name: this.$t('shared.advertisement').toString(),
                    },
                    {
                        id: SenderType.Service,
                        name: this.$t('shared.service').toString(),
                    },
                    {
                        id: SenderType.Awareness,
                        name: this.$t('shared.awareness').toString(),
                    },
                    {
                        id: SenderType.Warning,
                        name: this.$t('shared.warning').toString(),
                    },
                ];
                this.senderType = [];
                this.senderName = '';
                this.model.senderNames = [];
                break;
            case 2:
                this.senderTypeList = [
                    {
                        id: SenderType.Advertisement,
                        name: this.$t('shared.advertisement').toString(),
                    },
                    {
                        id: SenderType.Service,
                        name: this.$t('shared.service').toString(),
                    },
                    {
                        id: SenderType.Awareness,
                        name: this.$t('shared.awareness').toString(),
                    },
                ];
                this.senderType = [];
                this.senderName = '';
                this.model.senderNames = [];
                break;
            case 3:
                this.senderTypeList = [
                    {
                        id: SenderType.Advertisement,
                        name: this.$t('shared.advertisement').toString(),
                    },
                    {
                        id: SenderType.Service,
                        name: this.$t('shared.service').toString(),
                    },
                    {
                        id: SenderType.Awareness,
                        name: this.$t('shared.awareness').toString(),
                    },
                ];
                this.senderType = [];
                this.senderName = '';
                this.model.senderNames = [];
                break;
            case 4:
                this.senderTypeList = [
                    {
                        id: SenderType.Service,
                        name: this.$t('shared.service').toString(),
                    },
                ];
                this.senderType = [SenderType.Service];
                this.senderName = '';
                this.model.senderNames = [];
                break;
        }
        if (this.model.customerType === 4 && this.stepNumber === 5) {
            this.stepNumber = 4;
        }
    }

    @Watch('senderType', { deep: true })
    public onchangeSenderType() {
        this.senderName = '';
        if (this.senderType.includes(SenderType.Advertisement)) {
            this.senderNameLength = 8;
        } else if (this.senderType.includes(SenderType.Service) && this.model.customerType === 4) {
            this.senderNameLength = 9;
        } else {
            this.senderNameLength = 11;
        }
    }

    public hide() {
        this.showOperators = false;
    }
    public show() {
        this.showOperators = true;
    }

    public clearDataOnChageVaidationType() {
        this.model.crNumber = '';
        this.model.clientName = '';
        this.model.enterpriseUnifiedNumber = '';
    }

    private isValidComment(): boolean {
        const comment = this.model.comment ? this.model.comment.trim() : '';
        if (comment.length === 0) {
            return true;
        }
        if (comment.length < 3) {
            Toaster.error(this.$t('shared.commentMinLength').toString());
            return false;
        }
        this.model.comment = comment;
        return true;
    }


    public showsubmitRequestDialog(id: string) {
        this.submitRequestdialog = true;
    }
    public hidesubmitRequestDialog() {
        this.submitRequestdialog = false;
    }
    public async submitRequest() {
        if (!this.isValidComment()) return;
        const aiList = this.buildAIDocFieldsFromReviewRows();
        for (let i = 0; i < this.model.senderNames.length; i++) {
            const s = this.model.senderNames[i];
            (s as any).aIDecumentsFields = aiList;
        }

        const response = await this.addRequestService.post(this.model);
        if (response.isSuccess) {
            this.stepNumber = 7;
            this.addRequestService.addRequestEmail(response.result);
            const canRate = await this.ratingService.canRate(RatingServiceType.SenderNameRegistration);
            if (canRate) {
                this.showRatingDialog = true;
            }
        } else {
            Toaster.error(response.errorMessage);
        }
        this.hidesubmitRequestDialog();
    }

    public async suggest() {
        if (!this.showSuggestions) {
            const senderTypeSum = this.senderType.reduce((a, b) => a + b, 0);

            const response = await this.addRequestService.getSuggestedNames(this.model.clientName, senderTypeSum, this.model.customerType);
            if (Array.isArray(response)) {
                this.suggestedSenderNamesList = response;
            }
        }
        this.showSuggestions = !this.showSuggestions;
    }

    public updateSenderName(): void {
        this.senderName = this.selectedSuggestedSenderName || '';
        this.isAutoSuggest = true;
    }


    public onInputChange(): void {
        this.isAutoSuggest = false; // Reset flag when typing sender name manually
        this.senderNameSymbolError = null;
    }

    public async newRequest() {
        await this.reset();
        this.stepNumber = 1;
    }

    private hasAttachmentByType(type: AttachmentCategoryType): boolean {
        var target = String(type).toLowerCase();
        var list = this.model.senderRequestAttachments || [];
        for (var i = 0; i < list.length; i++) {
            var att = list[i];
            if (att && String(att.attachmentType).toLowerCase() === target) return true;
        }
        return false;
    }

    public addAttachment() {
        this.currentAttachment.attachmentType = this.attachmentType;
        this.currentAttachment.attachmentTypeName = this.attachmentCategoryList.filter(x => x.id === this.attachmentType)[0].name;
        this.model.senderRequestAttachments.push(this.currentAttachment);
        this.currentAttachment =
        {
            id: '',
            fileName: '',
            fileContent: '',
            file: null,
            attachmentType: '',
            attachmentTypeName: '',
            isDeleted: false,
        };
        var category = this.attachmentCategoryList.find(obj => obj.id === this.attachmentType);
        if (category != undefined) {
            this.deletedAttachmentCategoryList.push(category);
        }
        const index = this.attachmentCategoryList.findIndex(obj => obj.id === this.attachmentType);
        if (index !== -1) {
            this.attachmentCategoryList.splice(index, 1);
        }
        this.attachmentType = '';
        this.selectedFileName = '';
        this.fileNameRef.value = '';
    }

    public isNumberField(val: KeyboardEvent) {
        if (!this.validationService.isNumber(val.key)) {
            val.preventDefault();
        }
    }

    public isNumberFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (isNaN(paste)) {
            ev.preventDefault();
        }
    }

    public isSenderNameField(val: KeyboardEvent) {
        const pattern = /^[-a-zA-Z0-9._& ]*$/;
        if (!pattern.test(val.key)) {
            val.preventDefault();
        }
        const oneSpase = / +/g;
        if (this.senderName.endsWith(' ')) {
            if (oneSpase.test(val.key)) {
                val.preventDefault();
            }
        }
    }

    public isSenderNameFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        const pattern = /^[-a-zA-Z0-9._& ]*$/;
        if (!pattern.test(paste)) {
            ev.preventDefault();
        }
        const twoSpaces = /  +/g;
        if (twoSpaces.test(paste)) {
            ev.preventDefault();
        }
    }

    public get isValidSenderName(): boolean {
        const L = this.effectiveSenderLen(this.senderName);
        if (L === 0 || L > this.senderNameLength || this.senderType.length === 0) return false;

        if ((this.model.customerType === 1 || this.model.customerType === 4) && L < 2) return false;
        if ((this.model.customerType === 2 || this.model.customerType === 3) && L < 3) return false;

        return true;
    }

    public get canAddAttachment(): boolean {
        return (this.selectedFileName !== '' && this.attachmentType !== '');
    }

    public async AddSender() {
        this.senderNameSymbolError = null;
        if (/^[^a-zA-Z0-9]/.test(this.senderName)) {
            this.senderNameSymbolError = this.$t('shared.senderNameSymbolsError') as string;
            return;
        }
        if (/[^a-zA-Z0-9]$/.test(this.senderName)) {
            this.senderNameSymbolError = this.$t('shared.senderNameSymbolsError2') as string;
            return;
        }
        const normalized = this.normalizeSenderForCount(this.senderName);

        const senderTypeSum = this.senderType.reduce((a, b) => a + b, 0);

        if (this.keywordsList.some(b =>
            this.normalizeSenderForCount(b.name).toLowerCase() === normalized.toLowerCase())) {
            Toaster.error(this.$t('shared.senderNameShouldNotBeOneOfTheKeywords').toString());
            return;
        }

        if (/^\d+$/.test(normalized)) {
            Toaster.error(this.$t('shared.senderNameShouldbenumbersandChar').toString());
            return;
        }

        const low = normalized.toLowerCase();
        if (low.endsWith('-ad') || low.endsWith('-i')) {
            Toaster.error(this.$t('shared.errorSenderNameEnd').toString());
            return;
        }

        if (this.model.senderNames.some(b => this.sameSender(b.senderName, normalized))) {
            Toaster.error(this.$t('shared.errorSenderNameDuplicate').toString());
            return;
        }

        const availability = await this.addRequestService.checkSenderNameAvailability(normalized);
        if (availability && availability.isSuccess === false) {
            Toaster.error(this.$t('shared.SenderNameExist').toString());
            return;
        }


        this.model.senderNames.push({
            senderName: normalized,
            senderType: senderTypeSum,
            isCriticalSender: this.isCriticalSender,
            isAutoSuggest: this.isAutoSuggest,
            aIDecumentsFields: [],
            domainName: this.domainName
        });

        // Reset fields
        this.senderNameSymbolError = null;
        this.senderName = '';
        this.senderType = [];
        this.isCriticalSender = false;
        this.isAutoSuggest = false; // Reset flag after submit
        this.showSuggestions = false;
    }

    public getCustomerTypeText(typeId: number) {
        switch (typeId) {
            case 1:
                return this.$t('shared.government').toString();
            case 2:
                return this.$t('shared.charity').toString();
            case 3:
                return this.$t('shared.private').toString();
            case 4:
                return this.$t('shared.international').toString();
            default:
                return '-';
        }
    }

    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement:
                return this.$t('shared.advertisement').toString();
            case SenderType.Service:
                return this.$t('shared.service').toString();
            case SenderType.Awareness:
                return this.$t('shared.awareness').toString();
            case SenderType.Warning:
                return this.$t('shared.warning').toString();
            default:
                return '-';
        }
    }

    public deleteSender(id: number) {
        this.model.senderNames.splice(id, 1);
    }
    public deleteAttachment(id: number) {
        var requestAttachment = this.model.senderRequestAttachments[id];
        if (requestAttachment != undefined) {
            const requestAttachmentType = requestAttachment.attachmentType;
            var element = this.deletedAttachmentCategoryList.find(at => at.id == requestAttachmentType);
            if (element != undefined) {
                this.attachmentCategoryList.push(element);
            }
            var index = this.deletedAttachmentCategoryList.findIndex(at => at.id == requestAttachmentType);
            this.deletedAttachmentCategoryList.splice(index, 1);
            this.model.senderRequestAttachments.splice(id, 1);
        }
    }

    public onPickFile() {
        (this.$refs.fileName as any).click();
    }

    public onFilePicked(event: any) {
        const files: any[] = event.target.files;
        Array.prototype.forEach.call(files, (file, index) => {
            if (file.size > 3000000) {
                Toaster.error(this.$t('shared.fileSizeExceedsTheLimit').toString());
                this.fileNameRef.value = '';
            } else {
                this.selectedFileName = file.name;
                this.currentAttachment.file = file;  
                const reader = new FileReader();
                reader.onloadend = (fileData: any) => {
                    this.currentAttachment.fileContent = fileData.target.result.split(',')[1];
                    this.currentAttachment.fileName = file.name;
                };
                reader.readAsDataURL(file);
            }
        });
    }

    public get isValidStep(): boolean {
        //
        if (this.stepNumber === 1) {
            return (
                (this.model.verificationType == 1 ||
                    (this.model.verificationType == 0
                        && this.model.clientName.trim() !== ''
                        && (this.model.customerType === 3 || this.model.crNumber.trim() !== '')))
                && this.model.customerType !== 0
                && (this.model.enterpriseUnifiedNumber.trim() !== ''
                    || this.model.customerType === 1
                    || this.model.customerType === 4)
            );
        } else if (this.stepNumber === 2) {
            return (
                this.model.duration.toString().trim() !== '' &&
                this.model.duration.toString().trim() !== '0' &&
                this.model.senderNames.length !== 0 &&
                this.model.expiryDate !== "" &&
                new Date(this.model.expiryDate) > this.minDate
            );
        } else if (this.stepNumber === 3) {
            return (
                this.model.representativeMobile !== '' &&
                this.model.representativeName.trim() !== '' &&
                (this.model.customerType === 4 ||
                    this.model.representativeMobile.length === 9) &&
                (this.model.customerType === 4 ||
                    this.model.representativeMobile.startsWith('5')) &&
                this.model.representativeEmail !== '' &&
                (
                    ( this.model.representativeIdNumber.length === 10 
                        &&
                      this.model.representativeIdNumber.startsWith('1')
                        && 
                      this.model.verificationType == 1)
                       || this.model.verificationType == 0
                ) &&
                this.validationService.isValidEmail(this.model.representativeEmail)
            );
        }
        return true;
    }

    data() {
        return {
            expiryDateFromMenu: false,
            //today: new Date().toISOString().substr(0, 10), // "YYYY-MM-DD"
            today: moment().format('YYYY-MM-DD'),
            model: {
                expiryDate: null,
            },
        };
    }

    public get currentDate() {
        return moment().add(1, 'days').format('YYYY-MM-DD');
    }



    public async reset() {
        this.model = {
            duration: '1',
            startDate: '',
            clientName: '',
            crNumber: '',
            enterpriseUnifiedNumber: '',
            customerType: 0,
            representativeEmail: '',
            representativeMobile: '',
            representativeName: '',
            senderNames: [],
            senderRequestAttachments: [],
            requestType: 1,
            comment: '',
            expiryDate: '',
            representativeIdNumber: '',
            isAutoActivation: false,
            isAutoPaid: false,
            verificationType: 0,
            operators: [],
            hasTrademark: false,
            trademarkName: '',
            protectionDateFrom: '',
            protectionDateTo: '',
        };
        this.protectionFromMenu = false,
        this.protectionToMenu = false,
        this.verified = false;
        this.senderType = [];
        const attachmentCategoryData = await this.attachmentCategoryService.getAll();
        this.attachmentCategoryList = attachmentCategoryData.result;
        this.invalidAttachmentNote = null;
        this.aiUnavailable = false;
    }

    get reasonRequired(): boolean {
        return this.rating > 0 && this.rating <= 2;
    }

    get canSubmit(): boolean {
        return this.rating > 0 && (!this.reasonRequired || this.reason.trim().length > 0);
    }

    public async submitRating() {
        if (!this.canSubmit) return;
        this.submitting = true;
        const model: ServiceRatingModel = {
            rating: this.rating,
            reason: this.reason,
            serviceType: RatingServiceType.SenderNameRegistration,
        };
        const response = await this.ratingService.addRating(model);
        if (response.isSuccess) {
            Toaster.success(this.$t('shared.ratingSuccess').toString());
            this.resetForm();
            this.showRatingDialog = false;
        } else {
            Toaster.error(response.errorMessage);
        }
        this.submitting = false;
    }

    public resetForm() {
        this.rating = 0;
        this.reason = '';
    }

    @Watch('model.clientName')
    onClientNameChanged() {
        this.model.senderNames = [];
        this.suggestedSenderNamesList = [];
        this.selectedSuggestedSenderName = null;
        this.senderName = '';
        this.senderType = [];
        this.showSuggestions = false;
        this.isAutoSuggest = false;
    }
    public get representativeMobileError(): string {
        if (this.model.representativeMobile && !this.model.representativeMobile.startsWith('5') && this.model.customerType !== 4) {
            return this.$t('shared.NumberStart5').toString();
        }
        return '';
    }

    public get representativeEmailError(): string {
        if (this.model.representativeEmail && !this.validationService.isValidEmail(this.model.representativeEmail)) {
            return this.$t('shared.InvalidEmail').toString();
        }
        return '';
    }

    public get representativeIdError(): string {
        const id = this.model.representativeIdNumber;
        if (id && !id.startsWith('1')) {
            return this.$t('shared.IdStart1').toString();
        }
        else if (id && id.length !== 10) {
            return this.$t('shared.Id10digits').toString();
        }
       
        return '';
    }


    getMaskedManagerName(fullName: string): string {
        if (!fullName) return '';
        const honorifics = [
            "السيد", "سيد", "السيدة", "سيده", "السيده", "سيدة",
            "Mr", "Mrs", "Ms", "انسة", "أنسه", "أنسة", "انسه"
        ];

        const RLM = "\u200F";
        let parts = fullName.split(' ').filter(p => p);

        const prefixParts: string[] = [];
        while (parts.length && honorifics.some(h => this.pEquals(parts[0], h))) {
            prefixParts.push(parts.shift()!);
        }

        const firstName = parts[0] || '';
        const fatherName = parts[1] || '';
        const familyName = parts.length > 2 ? parts[parts.length - 1] : '';

        const maskedFather = fatherName
            ? fatherName[0] + (fatherName.length > 1 ? '*'.repeat(fatherName.length - 1) : '')
            : '';

        const maskedFamily = familyName
            ? familyName.slice(0, 2) + (familyName.length > 2 ? '*'.repeat(familyName.length - 2) + RLM : '')
            : '';

        return [
            ...prefixParts,
            firstName,
            maskedFather,
            maskedFamily
        ].filter(Boolean).join(' ');
    }

    pEquals(a: string, b: string): boolean {
        return a.replace(/[ةه]/g, "ه").toLowerCase() === b.replace(/[ةه]/g, "ه").toLowerCase();
    }

    public get hasMismatch(): boolean {
        const base = [
            'auth_number',
             'entity_name',
              'authorized_name_to_use',
               'authorized_mobile_to_use',
                'authorized_email_to_use'];

        const fieldsToCheck =
            this.model.customerType === 3 && this.model.verificationType === 1
                ? base.concat(['authorized_id', 'enterprise_unified_number'])
                : (this.model.customerType === 3 ? base.concat(['enterprise_unified_number']) : base);

        const hasFieldMismatch = this.aiReviewRows.some(row => fieldsToCheck.indexOf(row.fieldKey) !== -1 && row.status !== 0);

        const hasStampMismatch =
            !this.stampValidation.delegationLetterStamp ||
            !this.stampValidation.entityStamp ||
            (this.model.customerType === 3 ? !this.stampValidation.chamberStamp : false);

        return hasFieldMismatch || hasStampMismatch;
    }

    public confirmMismatchContinue() {
        this.hidemismatchFoundDialog();
        this.next();
    }

    get senderNameError(): string | null {
        const L = this.effectiveSenderLen(this.senderName);
        if (!L) return null;

        if ((this.model.customerType === 1 || this.model.customerType === 4) && L < 2) {
            return this.$t('shared.senderNameLength', { min: 2 }) as string;
        }
        if ((this.model.customerType === 2 || this.model.customerType === 3) && L < 3) {
            return this.$t('shared.senderNameLength', { min: 3 }) as string;
        }
        return null;
    }

    private normalizeAiResultDisplay(val: any): string {
        if (typeof val === 'string') {
            try { const parsed = JSON.parse(val); return this.normalizeAiResultDisplay(parsed); } catch { return val; }
        }
        if (Array.isArray(val)) {
            const out: string[] = [];
            for (let i = 0; i < val.length; i++) {
                const x = val[i];
                if (x && typeof x === 'object' && Object.prototype.hasOwnProperty.call(x, 'original') && x.original) {
                    out.push(x.original);
                } else {
                    out.push(String(x));
                }
            }
            return out.join(' - ');
        }
        if (val && typeof val === 'object' && Object.prototype.hasOwnProperty.call(val, 'original')) {
            const o = (val as any).original;
            return o ? String(o) : JSON.stringify(val);
        }
        return val != null ? String(val) : '';
    }

    private asBool(...vals: any[]): boolean {
        for (let i = 0; i < vals.length; i++) {
            const v = vals[i];
            if (typeof v === 'boolean') return v;
            if (typeof v === 'number') return v !== 0;
            if (typeof v === 'string') {
                const s = v.trim().toLowerCase();
                if (s === 'true' || s === '1' || s === 'yes') return true;
                if (s === 'false' || s === '0' || s === 'no') return false;
            }
        }
        return false;
    }
    private normalizeSenderForCount(raw: string): string {
        const s = String(raw || '');
        const permitted = s.replace(/[^-a-zA-Z0-9._& ]+/g, '');
        const collapsed = permitted.replace(/ {2,}/g, ' ');
        const trimmedEdges = collapsed.replace(/^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g, '');
        return trimmedEdges;
    }

    private effectiveSenderLen(raw: string): number {
        const normalized = this.normalizeSenderForCount(raw);
        const alnumOnly = normalized.replace(/[^A-Za-z0-9]/g, '');
        const alnumLen = alnumOnly.length;
        if (alnumLen === 2 || alnumLen === 3) return alnumLen;
        if (alnumLen > 3) return normalized.length;
        return alnumLen;
    }

    private sameSender(a: string, b: string): boolean {
        return this.normalizeSenderForCount(a).toLowerCase() ===
            this.normalizeSenderForCount(b).toLowerCase();
    }

    private failAndBack(errors: string[]) {
        const uniq = Array.from(new Set(errors.filter(Boolean)));
        if (uniq.length === 0) uniq.push(this.$t('shared.validationFailed') as string);
        for (let i = 0; i < uniq.length; i++) Toaster.error(uniq[i]);

        this.stepNumber = 4;
    }

    private reasonCodeToMessage(code: any, payload?: any): string {
        if (code == null) return this.$t('shared.validationFailed').toString();

        const raw = String(code).trim();
        if (!raw) return this.$t('shared.validationFailed').toString();

        if (/^SavingFailed/i.test(raw)) {
            const m = raw.match(/\{(.+)\}$/);
            const failed = (m && m[1]) ? m[1] : '';
            return this.$t('errors.savingFailed', { files: failed }).toString();
        }
        if (/\}IsRequired\.?$/i.test(raw)) {
            const fields = raw.replace(/IsRequired\.?$/i, '').replace(/^\{|\}$/g, '');
            return this.$t('errors.missingFields', { fields }).toString();
        }

        const i18nKey = `errors.${raw}`;
        const translated: any = this.$t(i18nKey);
        return (typeof translated === 'string' && translated !== i18nKey) ? translated : raw;
    }

    private extractValidationMessages(payload: any): { alerts: string[]; hardErrors: string[] } {
        let alerts: string[] = [];
        let hardErrors: string[] = [];

        if (!payload || typeof payload !== 'object') {
            return { alerts, hardErrors };
        }

        const sid = payload.sender_id_validation || payload.Sender_Id_Validation || payload.SenderIDValidation || null;

        let reasonsRaw: any = null;
        if (sid && typeof sid === 'object') {
            reasonsRaw =
                sid.reasonsEN != null ? sid.reasonsEN :
                    sid.ReasonsEN != null ? sid.ReasonsEN :
                        sid.reasonsEn != null ? sid.reasonsEn :
                            null;
        }

        let reasonList: string[] = [];
        if (Array.isArray(reasonsRaw)) {
            reasonList = reasonsRaw.map((x: any) => String(x));
        } else if (reasonsRaw != null) {
            const s = String(reasonsRaw);
            try {
                const parsed = JSON.parse(s);
                if (Array.isArray(parsed)) {
                    reasonList = parsed.map((x: any) => String(x));
                } else {
                    reasonList = s.split(',').map(x => x.trim()).filter(Boolean);
                }
            } catch {
                reasonList = s.split(',').map(x => x.trim()).filter(Boolean);
            }
        }

        const seen: Record<string, boolean> = {};
        for (const r of reasonList) {
            const msg = this.reasonCodeToMessage(r, payload);
            if (msg && !seen[msg]) {
                alerts.push(msg);
                seen[msg] = true;
            }
        }

        if (payload.valid === false && typeof payload.message === 'string' && payload.message.trim()) {
            hardErrors.push(this.reasonCodeToMessage(payload.message.trim(), payload));
        }
        if (Array.isArray(payload.errors)) {
            for (let j = 0; j < payload.errors.length; j++) {
                hardErrors.push(this.reasonCodeToMessage(String(payload.errors[j]), payload));
            }
        }
        if (typeof payload.error === 'string' && payload.error.trim()) {
            hardErrors.push(this.reasonCodeToMessage(payload.error.trim(), payload));
        }
        if (typeof payload.error_message === 'string' && payload.error_message.trim()) {
            hardErrors.push(this.reasonCodeToMessage(payload.error_message.trim(), payload));
        }

        return { alerts, hardErrors };
    }


    private isShortNameForRules(name: string): boolean {
        const len = this.effectiveSenderLen(name);
        const t = this.model.customerType;

        if (t === 1) return len === 2 || len === 3;
        if (t === 2 || t === 3) return len === 3;
        return false;
    }

    private requiresSaudiDomainAttachment(): boolean {
        const list = this.model.senderNames || [];
        for (let i = 0; i < list.length; i++) {
            const s = list[i];
            const nm = (s && s.senderName) ? s.senderName : '';
            if (this.isShortNameForRules(nm)) return true;
        }
        return false;
    }

    private requiresTrademarkAttachmentMandatory(): boolean {
        if (this.model.customerType !== 3) return false; 
        const list = this.model.senderNames || [];
        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            const len = this.effectiveSenderLen((item && item.senderName) ? item.senderName : '');
            if (len === 3) return true;
        }
        return false;
    }

    private hasInvalidUploadedDocument(payload: any): boolean {
        if (!payload || typeof payload !== 'object') return false;

        const checks = [
            { type: AttachmentCategoryType.DelegationLetter, section: 'authorization_validation' },
            { type: AttachmentCategoryType.CommercialRegistrationDocument, section: 'commercial_registration_validation' },
            { type: AttachmentCategoryType.HRSDLicense, section: 'hrsd_license_validation' },
            { type: AttachmentCategoryType.Trademark, section: 'intellectual_property_validation' },
            { type: AttachmentCategoryType.SaudiDomain, section: 'domain_validation' },
        ];

        for (let i = 0; i < checks.length; i++) {
            const c = checks[i];
            if (this.hasAttachmentByType(c.type)) {
                const sec = payload[c.section];
                if (sec && this.isExplicitFalse(sec.valid_document)) {
                    return true;
                }
            }
        }
        return false;
    }

    private isExplicitFalse(val: any): boolean {
        if (typeof val === 'boolean') return val === false;
        if (typeof val === 'string') {
            const s = val.trim().toLowerCase();
            return s === 'false';
        }
        return false;
    }

    public statusChipColor(status: number) {
        if (status === 0) return 'green lighten-4';
        if (status === 1) return 'red lighten-4';
        return 'orange lighten-4';
    }
    public statusTextColor(status: number) {
        if (status === 0) return 'green';
        if (status === 1) return 'red';
        return 'orange';
    }
    public statusLabel(status: number) {
        if (status === 0) return this.$t('shared.matched');
        if (status === 1) return this.$t('shared.notMatched');
        return this.$t('shared.missing');
    }
    public statusIconColor(status: number) {
        if (status === 0) return 'green';
        if (status === 1) return 'red';
        return 'orange';
    }
    public statusIcon(status: number) {
        if (status === 0) return 'mdi-check-circle';
        if (status === 1) return 'mdi-close-circle';
        return 'mdi-alert-circle';
    }

    domainRequired(senderName: string): boolean {
        const len = this.effectiveSenderLen(senderName);
        const t = this.model.customerType;
        const isGov = t === 1;
        const isCharity = t === 2;
        const isPrivate = t === 3;

        return (isGov && (len === 2 || len === 3)) || ((isPrivate || isCharity) && len === 3);
    }

    public get isReviewDisabled(): boolean {
        return this.loadingAIReview;
    }

    get shouldMaskRepresentative(): boolean {
        return this.model.customerType === 3 && this.model.verificationType === 1;
    }
    
    get maskedRepresentativeName(): string {
        const n = this.model.representativeName || '';
        return this.shouldMaskRepresentative ? this.getMaskedManagerName(n) : n;
    }

    get isBackDisabled(): boolean {
        return this.stepNumber === 5 && this.loadingAIReview;
    }

    private toAsciiDigits(s: string): string {
        const map: Record<string, string> = {
            '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
            '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9'
        };
        return String(s || '').replace(/[٠-٩]/g, d => (
            Object.prototype.hasOwnProperty.call(map, d) ? map[d] : d
        ));
    }

    private formatGregorianYMD(d: Date): string {
        const y = d.getUTCFullYear();
        const m = String(d.getUTCMonth() + 1).padStart(2, '0');
        const day = String(d.getUTCDate()).padStart(2, '0');
        return `${y}/${m}/${day}`;
    }

    private hijriUmmAlQuraToGregorian(hijri: string): string {
        if (!hijri) return '';
        const ascii = this.toAsciiDigits(hijri).trim();
        const m = ascii.match(/^(\d{3,4})[\/\-.](\d{1,2})[\/\-.](\d{1,2})$/);
        if (!m) return '';

        const targetY = m[1].padStart(4, '0');
        const targetM = m[2].padStart(2, '0');
        const targetD = m[3].padStart(2, '0');

        let fmtHijri: Intl.DateTimeFormat;
        try {
            fmtHijri = new Intl.DateTimeFormat('en-u-ca-islamic-umalqura', {
                timeZone: 'UTC',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        } catch {
            return '';
        }

        const dayMs = 24 * 60 * 60 * 1000;
        let t = Date.UTC(1937, 2, 14);      
        const end = Date.UTC(2077, 10, 16);

        for (; t <= end; t += dayMs) {
            const d = new Date(t);
            const parts = fmtHijri.formatToParts(d);

            let y = '';
            let mo = '';
            let da = '';
            for (let i = 0; i < parts.length; i++) {
                const p = parts[i];
                if (p.type === 'year') y = p.value;
                else if (p.type === 'month') mo = p.value;
                else if (p.type === 'day') da = p.value;
            }

            if (y === targetY && mo === targetM && da === targetD) {
                return this.formatGregorianYMD(d);
            }
        }
        return '';
    }

    private toGregorianDisplay(val: string): string {
        if (!val) return '';
        var s = String(val).trim();

        var g = this.hijriUmmAlQuraToGregorian(s);
        if (g) return g;

        var m = (moment as any).utc(s, ['YYYY-MM-DD', 'YYYY/MM/DD', 'DD/MM/YYYY', 'MM/DD/YYYY'], true);
        if (m && m.isValid && m.isValid()) {
            return m.format('YYYY/MM/DD');
        }

        return s;
    }

    get attachmentTooltip(): string {
        const gov = this.$t('shared.requiredDocGovernment').toString(); 
        const priv = this.$t('shared.requiredDocPrivate').toString();   
        const chrt = this.$t('shared.requiredDocCharity').toString();    
        const addl = this.$t('shared.additionalFilesSelectCategory').toString();
        const max = this.$t('shared.maxFileSize3MB').toString();

        let firstLine = '';
        switch (this.model.customerType) {
            case 1: firstLine = gov; break;     
            case 2: firstLine = chrt; break;    
            case 3: firstLine = priv; break;   
            default: firstLine = gov;           
        }
        return [firstLine, addl, max].join('\n');
    }

    private isAIUnavailablePayload(payload: any): boolean {
        if (!payload || typeof payload !== 'object') return true;

        const hasMsg = payload.message !== undefined && payload.message !== null;
        const hasMsgAlt = payload.Message !== undefined && payload.Message !== null;
        const msg = String(hasMsg ? payload.message : (hasMsgAlt ? payload.Message : '')).trim();
        if (msg.indexOf('InternalProcessingFailed') === 0) return true;

        const hasValidLower = typeof payload.valid === 'boolean';
        const hasValidUpper = typeof payload.Valid === 'boolean';
        const valid = hasValidLower ? payload.valid : (hasValidUpper ? payload.Valid : true);

        const sections = [
            payload.authorization_validation,
            payload.commercial_registration_validation,
            payload.hrsd_license_validation,
            payload.intellectual_property_validation,
            payload.domain_validation,
            payload.sender_id_validation
        ];
        const hasAnySection = sections.some(function (s) { return !!(s && typeof s === 'object'); });

        const hasSecsLower = payload.validation_processing_time_seconds !== undefined && payload.validation_processing_time_seconds !== null;
        const hasSecsUpper = payload.ValidationProcessingTimeSeconds !== undefined && payload.ValidationProcessingTimeSeconds !== null;
        const secsRaw = hasSecsLower ? payload.validation_processing_time_seconds : (hasSecsUpper ? payload.ValidationProcessingTimeSeconds : 0);
        const secs = Number(secsRaw);
        const isZeroTime = !isNaN(secs) && Math.abs(secs) < 1e-9;

        return (valid === false) && !hasAnySection && isZeroTime;
    }

    private markAIUnavailable(): void {
        this.endLoading(false);
        this.aiUnavailable = true;
        this.aiReviewRows = [];     
        this.aiReviewAlerts.splice(0);
        this.invalidAttachmentNote = this.$t('shared.aiUnavailableProceed').toString();
        this.stepNumber = 5;
    }

    get shouldShowDomain(): boolean {
        const t = this.model.customerType;
        const list = this.model.senderNames || [];
        return list.some(s => this.domainRequired(s.senderName));
    }

    public get isSenderTypeEmpty(): boolean {
        return this.senderType.length === 0;
    }

    public get senderNameTitle(): string {
        return this.isSenderTypeEmpty
            ? this.$t('shared.selectSenderType').toString()
            : '';
    }

    public get senderNameInputStyle(): any {
        return {
            cursor: this.isSenderTypeEmpty ? 'default' : 'text',
        };
    }

    public get addSenderButtonStyle(): any {
        return {
            cursor: this.isSenderTypeEmpty ? 'default' : 'pointer'
        };
    }

    public get isSuggestDisabled(): boolean {
        return this.isSenderTypeEmpty;
    }

}
